<template>
    <div class='constitution'>
        <div class="detection marginSty">
            <div class="testItem" v-for="(item, index) in hotData" :key="index">
                <div class="title" v-if="index == '0'">
                    <div class="subtitle">一、热性体质检测表</div>
                </div>
                <!-- 问卷内容 -->
                <div class="questionnaire">
                    <div class="questTitle">{{index+1}}. {{ item.Title }}</div>
                    <!-- 单选框 -->
                    <van-radio-group v-model="item.value" direction="horizontal">
                        <van-radio :name="el.Id" v-for="el in item.Content" :key="el.Id" checked-color="#56D1E6">{{ el.Title }}</van-radio>
                    </van-radio-group>
                </div>
            </div>
        </div>
        <div class="detection">
            <div class="testItem" v-for="(item, index) in ColdData" :key="index">
                <div class="title" v-if="index == '0'">
                    <div class="subtitle">二、寒性体质检测表</div>
                </div>
                <!-- 问卷内容 -->
                <div class="questionnaire">
                    <div class="questTitle">{{index+1}}. {{ item.Title }}</div>
                    <!-- 单选框 -->
                    <van-radio-group v-model="item.value" direction="horizontal">
                        <van-radio :name="el.Id" v-for="el in item.Content" :key="el.Id" checked-color="#56D1E6">{{ el.Title }}</van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="btn">
                <van-button round type="info" @click="submit">提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { GetHealthQuestionList, CustomerFoodResult } from '@/api/index'
import { mapGetters } from 'vuex'

export default {
  components: {

  },
  computed: {
    ...mapGetters([
      'userid'
    ])
  },
  data () {
    return {
      dietTyerapyUrl: `${this.$imgDomain}/www/HealthingCore/dietTyerapy2.png`,
      hotData: [],
      ColdData: [],
      healData: [],
      userData: {}
    }
  },
  props: {

  },
  created () {
    if (this.$query('healData')) {
      this.healData = JSON.parse(this.$query('healData'))
    }
    if (this.$query('userData')) {
      this.userData = JSON.parse(this.$query('userData'))
    }

    this.getHealthQuestionListData(this.userData)
  },
  mounted () {

  },
  methods: {
    getHealthQuestionListData (data) {
      const parmas = {
        sex: data.sex
      }
      GetHealthQuestionList(parmas).then(res => {
        const { data } = res

        if (data.hotData && data.ColdData) {
          this.hotData = data.hotData
          this.ColdData = data.ColdData
        }
      })
    },
    submit () {
      const hotData = []
      const ColdData = []
      this.hotData.forEach(item => {
        if (item.value) {
          hotData.push({ Id: item.value })
        }
      })
      this.ColdData.forEach(item => {
        if (item.value) {
          ColdData.push({ Id: item.value })
        }
      })

      // 提交接口
      this.addCustomerFoodResult(this.userData, this.healData, hotData, ColdData)
    },
    addCustomerFoodResult (userData, healData, hotData, ColdData) {
      const parmas = Object.assign(userData)
      parmas.healingJson = JSON.stringify(healData)
      parmas.hotJson = JSON.stringify(hotData)
      parmas.coldJson = JSON.stringify(ColdData)
      console.log(parmas)
      console.log(this.userid)
      parmas.userId = this.userid
      CustomerFoodResult(parmas).then(res => {
        const { data } = res
        if (data) {
          this.$toast('提交成功')
          this.$router.push({ path: '/summary', query: { summaryData: JSON.stringify(data) } })
        }
      })
    }

  },
  watch: {

  }
}
</script>
<style lang='scss' scoped>
.constitution {
    background: url('https://gotocloud8-open-sx.oss-cn-hangzhou.aliyuncs.com/www/HealthingCore/dietTyerapy2.png') no-repeat;
    background-size: 100%;
    background-color: #F5F5F5;
    padding: 0 15px;
    .detection {
        .testItem {
            padding: 20px;
            border-radius: 10px;
            background: #fff;
            margin-bottom: 10px;
            .title {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px 0;
                .text {
                    color: #333333;
                    font-weight: 700;
                    font-size: 20px;
                    position: relative;
                    margin-bottom: 30px;
                }
                .text::before,
                .text::after{
                    content: "";
                    position: absolute;
                    top: 10px;
                    width: 10px;
                    height: 10px;
                    border-radius: 5px;
                    background-color: #57D1E6;
                }
                .text::before {
                    left: -20px;
                }
                .text::after {
                    right: -20px;
                }
            }
            .subtitle {
                width: 100%;
                font-size: 18px;
                font-weight: 700;
            }
            .questionnaire {
                .questTitle {
                    color: #999999;
                    font-size: 16px;
                    font-weight: bold;
                }
                /deep/ .van-radio-group {
                    display: flex;
                }
                /deep/ .van-radio {
                    width: 50%;
                    margin: 15px 0 0;
                }
                /deep/ .van-radio__icon {
                    height: auto;
                    .van-icon {
                        width: 1em;
                        height: 1em;
                        line-height: 1;
                    }
                }
                /deep/ .van-radio__icon--checked + .van-radio__label {
                    color: #56D1E6;
                }
                /deep/ .van-radio__label {
                    font-size: 15px;
                    color: #333333;
                    font-weight: bold;
                }
            }
        }
    }
    .marginSty {
        margin-top: 120%;
    }

    .btn {
        text-align: center;
        padding: 40px 0;
        /deep/ .van-button {
            background: linear-gradient(-58deg,#6dd6da 0%, #52cfe6 100%);
            border: none;
            width: 200px;
            .van-button__text {
                font-size: 20px;
                font-weight: 700;
            }
        }
    }
}
</style>
